import { Component, Inject } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { DocumentAdditionalExpensesModel, DocumentAdditionalExpensesModelSAP, IDocumentAdditionalExpensesModel, IDocumentAdditionalExpensesModelSAP, IMarketingDocument, IMarketingDocumentSAP, MarketingDocument, MarketingDocumentSAP } from 'src/app/core/models/masters/marketing-document.model';
import { mapper } from 'src/app/infrastructure/infrastructure-services/common/mapper';
import { WrapperStandardFilter } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { GenericEntryForm } from 'src/app/infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';

@Component({
  selector: 'app-freight-detail',
  templateUrl: './freight-detail.component.html',
  styleUrls: ['./freight-detail.component.css']
})

export class FreightDetailComponent extends GenericEntryForm<IDocumentAdditionalExpensesModel, IDocumentAdditionalExpensesModelSAP> {
  dataSource = new MatTableDataSource();
  table!: MatTable<Element>;
  local_data: any;
  displayedColumns = ['name', 'netAmount', 'taxCode', 'taxSum', 'lineGross', 'remarks', 'action'];


  constructor(agenericRepository: GenericService<IDocumentAdditionalExpensesModel>, public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<IDocumentAdditionalExpensesModel>>,
    public agenericRepositoryForCfl: GenericService<IDocumentAdditionalExpensesModel>,
    public routerForCfl: Router,
    public snackbarService: BaseService<any>,
    @Inject(MAT_DIALOG_DATA) data: any,
    @Inject(MAT_DIALOG_DATA) private data1: any,
    private dbService: NgxIndexedDBService,
    public matDialogforCfl: MatDialog, dialog: MatDialog, router: Router,
    public dialogRef: MatDialogRef<FreightDetailComponent>, private activated: ActivatedRoute) {
    super(agenericRepository, router, dialog);
    this.local_data = { ...data };
    console.log('localData', this.local_data)
    let frieght = new DocumentAdditionalExpensesModel();
    let frieghtSAP = new DocumentAdditionalExpensesModelSAP();
    //frieght.expenseCode = this.activatedRoute.snapshot.params['id'];
    this.setEntryFormDataSource = frieght;
    this.setEntryFormDataSourceSAP = frieghtSAP;
    // this.addRow();


  }

  selectedData: any;
  onOpenDropDown(value: any, index: number) {

    this.setObjectType = this.activated.snapshot.data['ObjType'];
    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    let genCFL = new GenericCflViewComponent<IDocumentAdditionalExpensesModel>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data1, this.dbService);
    if (value == 'frightTaxCode') {
      genCFL.setCflTitle = "Fright Details";
      genCFL.setCflViewDataSourceURL = 'Freight/GetFreightListService';
      genCFL.setCflDisplayedColumnsNamesList = ['expenseCode', 'name', 'taxLiable'];
      genCFL.setCflSelectedData = this.local_data.frieghtDetails[index].expenseCode
      genCFL.setSortColumn = "expenseCode";
    }
    if (value == 'taxCode') {
      genCFL.setCflTitle = "Tax Code";
      genCFL.setCflViewDataSourceURL = 'SalesTaxCodes/GetSalesTaxCodesListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name', 'rate'];
      genCFL.setCflSelectedData = this.local_data.frieghtDetails[index].taxCode;
      genCFL.setSortColumn = "name";


      filter.Key = 'freight';
      filter.OperatorType = 'contains';
      filter.Value = 'Y'
      genCFL.setCflFilterArray = filter;
    }
    genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
      if (res != undefined && res.event != undefined) {
        console.log(res.event);
        this.selectedData = res.event;
        if (this.btnText == 'Language.OkText') {
          this.btnText = 'Language.UpdateText';
        }

        if (value == 'frightTaxCode') {

          const exists = this.local_data.frieghtDetails.some((item: any) => item.expenseCode === res.event.expenseCode);

          if (exists) {

            this.snackbarService.showMessage("You cannot select the same freight again.", "X");
            this.deleteRow(index)
            return


          } else {

            this.local_data.frieghtDetails[index].expenseName = res.event.name;
            this.local_data.frieghtDetails[index].expenseCode = res.event.expenseCode;

          }

        }
        if (value == 'taxCode') {
          this.local_data.frieghtDetails[index].taxCode = res.event.code;
          this.local_data.frieghtDetails[index].taxName = res.event.name;
          this.local_data.frieghtDetails[index].taxPercent = res.event.rate;
          let rate = parseFloat(res.event.rate) || 0;
          let lineTotal = parseFloat(this.local_data.frieghtDetails[index].lineTotal) || 0;
          this.local_data.frieghtDetails[index].taxSum = (lineTotal * (rate / 100)).toFixed(2);
          this.local_data.frieghtDetails[index].lineGross = lineTotal + parseFloat(this.local_data.frieghtDetails[index].taxSum || '0');
        }

      }
    })
  }

  changeNetAmount(index: any) {
    let taxPercent = parseFloat(this.local_data.frieghtDetails[index].taxPercent) || 0;
    let lineTotal = parseFloat(this.local_data.frieghtDetails[index].lineTotal) || 0;
    this.local_data.frieghtDetails[index].taxSum = (lineTotal * (taxPercent / 100)).toFixed(2);
    this.local_data.frieghtDetails[index].lineGross = lineTotal + parseFloat(this.local_data.frieghtDetails[index].taxSum || '0');
  }

  addRow() {
    let lineItem = new DocumentAdditionalExpensesModel();
    this.local_data.frieghtDetails.push(lineItem);
    this.local_data.frieghtDetails = [...this.local_data.frieghtDetails];
  }

  deleteRow(index: number) {
    this.local_data.frieghtDetails.splice(index, 1);
    this.local_data.frieghtDetails = [...this.local_data.frieghtDetails];
  }


  get freightTotalSum() {
    return this.local_data.frieghtDetails.reduce((sum: number, item: any) => sum + +item.lineTotal, 0);
  }

  get freightTaxSum() {
    return this.local_data.frieghtDetails.reduce((sum: number, item: any) => sum + +item.taxSum, 0);
  }

  saveFreight() {
    this.dialogRef.close({
      event: true, value:
      {
        frieghtDetails: this.local_data.frieghtDetails,
        freightSum: this.freightTotalSum,
        freightTaxSum: this.freightTaxSum
      }
    });
  }

}

